import { useState } from "react";

import { CustomModel, CustomModelFormValues } from "../types";
import { useCustomParametersStore } from "../CustomModelsCreation/CustomParameters/custom-parameters-store";

import { useLLMProviderStore } from "@/providers";

export const useCustomModelsControls = ({
  setIsConfirmationModalOpen,
}: {
  setIsConfirmationModalOpen: (isConfirmationModalOpen: boolean) => void;
}) => {
  const { store: llmProviderStore } = useLLMProviderStore();
  const [isOpen, setIsOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const store = useCustomParametersStore();
  const [defaultValues, setDefaultValues] = useState<CustomModelFormValues["create_custom_model"]>({
    provider: "",
    modelName: "",
    displayName: "",
    modelType: "chat",
    baseModel: "",
    apiKey: "",
    id: undefined,
  });

  const onEditModel = (model: CustomModel, isViewing?: boolean, providerNameFallback = "") => {
    setDefaultValues({
      provider:
        llmProviderStore.providers.find(provider => provider.id === model.provider_id)?.name ??
        model.provider_name ??
        providerNameFallback,
      modelName: model.llm_model_name,
      displayName: model.display_name ?? "",
      modelType: model.is_chat ? "chat" : "completion",
      baseModel: model.base_model ?? "",
      apiKey: "••••••••••••••••••••••••",
      id: model.id,
    });
    store.setSavedParameters(model.params);
    if (isViewing) {
      store.setIsViewing(true);
    } else {
      store.setIsEditing(true);
    }
    setIsOpen(true);
  };

  const onOpenChange = (open: boolean) => {
    if (!open && !store.isViewing && store.areParametersDifferent) {
      setIsConfirmationModalOpen(true);

      return;
    }

    setIsOpen(open);

    if (!open) {
      setDefaultValues({
        provider: "",
        modelName: "",
        displayName: "",
        modelType: "chat",
        baseModel: "",
        apiKey: "",
        id: undefined,
      });
      setActiveStep(0);
      store.reset();
      if (store.isViewing) {
        store.setIsViewing(false);
      } else {
        store.setIsEditing(false);
      }
    }
  };

  const onAddModel = (providerName = "") => {
    store.reset();
    store.setIsEditing(false);
    store.setIsViewing(false);
    setDefaultValues({
      provider: providerName,
      modelName: "",
      displayName: "",
      modelType: "chat",
      baseModel: "",
      apiKey: "",
      id: undefined,
    });
    setIsOpen(true);
  };

  return {
    onEditModel,
    onAddModel,
    onOpenChange,
    defaultValues,
    isOpen,
    setIsOpen,
    activeStep,
    setActiveStep,
  };
};
